import React from "react";
import "./footer.css";

function Footer() {
  return (
    <footer className="footer">
      <p>
        This project was coded by{" "}
        <a
          className="footer_link"
          href="https://tomaritech.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Tomari Southern
        </a>{" "}
        and is open-sourced on{" "}
        <a
          className="footer_link"
          href="https://github.com/TomariCodes/weather-react"
          target="_blank"
          rel="noopener noreferrer"
        >
          GitHub
        </a>{" "}
        and{" "}
        <a
          className="footer_link"
          href="https://tomaris-weather-react.netlify.app/"
          target="_blank"
          rel="noopener noreferrer"
        >
          hosted on netlify
        </a>
        .
      </p>
    </footer>
  );
}

export default Footer;